import { createFileRoute } from "@tanstack/react-router";
import Siding from "@/pages/Siding";
import { seo, breadcrumbSchema } from "@/lib/seo";

export const Route = createFileRoute("/_site/siding")({
  head: () =>
    seo({
      title: "LP SmartSide Siding Contractor | Minneapolis, MN",
      description:
        "Cedar Creek Construction installs and repairs LP SmartSide engineered wood siding across the Twin Cities. Free estimates—call (612) 298-9865.",
      path: "/siding",
      jsonLd: breadcrumbSchema([
        { name: "Home", path: "/" },
        { name: "Siding", path: "/siding" },
      ]),
    }),
  component: Siding,
});
